import { render, staticRenderFns } from "./DoctorCertificationList.vue?vue&type=template&id=01bc224c&scoped=true&"
import script from "./DoctorCertificationList.vue?vue&type=script&lang=js&"
export * from "./DoctorCertificationList.vue?vue&type=script&lang=js&"
import style0 from "./DoctorCertificationList.vue?vue&type=style&index=0&id=01bc224c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bc224c",
  null
  
)

export default component.exports